import { getWhatsAppLink } from './constants.js';
import { FINANCE_TERMS, isMoneyValue, partnerBalanceDirections } from './operationalFinanceTerms.js';
export const normalizeWhatsAppPhone = (phone) => String(phone || '')
    .replace(/[^\d+]/g, '')
    .replace(/^\+/, '')
    .replace(/^0+/, '');
export const buildDebtWhatsAppMessage = (entity, entityType) => {
    const name = entity?.name || 'العميل';
    const canonicalVisit = entity?.source === 'canonical_visit_ar' && Boolean(entity?.visitId);
    const validAmount = (value) => isMoneyValue(value) && Number(value) >= 0;
    const directions = canonicalVisit
        ? { workshop: entity.debitBalance, party: entity.creditBalance }
        : partnerBalanceDirections(entity);
    const available = entity?.financialDataAvailable !== false
        && (canonicalVisit || entity?.financialDataAvailable === true)
        && validAmount(directions.workshop) && validAmount(directions.party);
    const debit = Number(directions.workshop);
    const credit = Number(directions.party);
    const typeLabel = entityType === 'supplier' ? 'المورد' : 'العميل';
    const fmt = (n) => Number(n || 0).toLocaleString('ar-SA', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    const today = new Date().toLocaleDateString('ar-SA');
    const lines = [
        `السلام عليكم ${name} 🌟`,
        `كشف حساب ${typeLabel} — ${today}`,
        '━━━━━━━━━━━━━━━',
    ];
    if (!available || !['customer', 'supplier'].includes(entityType)) {
        lines.push('بيانات الرصيد غير متاحة حاليًا؛ لا يمكن تحديد مبلغ للمطالبة أو التسوية.');
        return lines.join('\n');
    }
    if (canonicalVisit && validAmount(entity?.dueAmount) && validAmount(entity?.paidAmount)) {
        lines.push(`• إجمالي الزيارة المعتمد: ${fmt(entity.dueAmount)} ر.س`);
        lines.push(`• المسدد من إجمالي الزيارة: ${fmt(entity.paidAmount)} ر.س`);
    }
    if (debit > 0)
        lines.push(`• ${FINANCE_TERMS.workshop} على ${typeLabel}: ${fmt(debit)} ر.س`);
    if (credit > 0)
        lines.push(`• ${entityType === 'supplier' ? FINANCE_TERMS.supplier : FINANCE_TERMS.customer} لدى الورشة: ${fmt(credit)} ر.س`);
    if (debit === 0 && credit === 0)
        lines.push('لا يوجد رصيد متبقٍ لأي طرف في هذا الكشف.');
    lines.push('━━━━━━━━━━━━━━━');
    if (debit > 0 && credit > 0)
        lines.push('المبلغان معروضان كلٌ على حدة؛ لم تُجرَ مقاصة بينهما.');
    lines.push('');
    lines.push('نأمل مراجعة الرصيد والتواصل معنا لإتمام التسوية. شاكرين تعاونكم 🙏');
    return lines.join('\n');
};
export const buildDebtWhatsAppDraft = (entity, entityType) => {
    const phone = normalizeWhatsAppPhone(entity?.phone || entity?.whatsapp || '');
    const message = buildDebtWhatsAppMessage(entity, entityType);
    return {
        id: `${entityType}-${entity?.id || entity?.name || Math.random().toString(36).slice(2)}`,
        entityId: entity?.id,
        entityType,
        name: entity?.name || '-',
        phone,
        message,
        url: phone ? getWhatsAppLink(phone, message) : '',
    };
};
